/** Floor abbreviated balances so a rounded label never promises money the player lacks. */
export function compactWallet(value: number): string {
  const amount = Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
  for (const [unit, suffix] of [
    [1_000_000_000, 'млрд'],
    [1_000_000, 'млн'],
    [1_000, 'тыс'],
  ] as const) {
    if (amount >= unit)
      return `${(Math.floor((amount / unit) * 10) / 10).toLocaleString('ru-RU')} ${suffix}`;
  }
  return amount.toLocaleString('ru-RU');
}
